import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setDailyChecklistPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useDailyChecklistSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getDailyChecklistSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.daily_checklist_page?.daily_checklist_section}`);
      console.log("🚀 ~ getDailyChecklistSectionJson ~ data:", response);
      console.log("🚀 ~ getDailyChecklistSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setDailyChecklistPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Daily Checklists section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getDailyChecklistSectionJson();
  }, [getDailyChecklistSectionJson]);

  return {
    data,
    loading,
    error,
    getDailyChecklistSectionJson,
    fetchOnMount,
    refetch: getDailyChecklistSectionJson
  };
};

export default useDailyChecklistSection;
